import { useQuery } from '@tanstack/react-query';
import { type LiveResource, toLiveResource } from '@/data/liveResource';
import { config } from './config';

export type Geo = {
  visitor: { lat: number; lon: number; city: string | null } | null;
  edge: {
    region: string;
    city: string | null;
    lat: number | null;
    lon: number | null;
  } | null;
};

const fetchGeo = async (): Promise<Geo> => {
  const res = await fetch(config.url);
  return res.json();
};

export const useGeo = (): LiveResource<Geo> => {
  const query = useQuery({ queryKey: ['geo'], queryFn: fetchGeo });
  return toLiveResource(query, { source: () => 'vercel' });
};
